import { Vector3 } from "three"

export default function tweenVector3To(
  source: Vector3,
  target: Vector3,
  duration: number,
  epsilon = 0.0001,
): Promise<void> {
  const start = performance.now()
  const startPos = source.clone()
  const delta = new Vector3().subVectors(target, startPos)

  return new Promise((resolve) => {
    function animate(now: number) {
      const elapsed = now - start
      const progress = Math.min(elapsed / duration, 1)

      source.copy(startPos).addScaledVector(delta, progress)

      if (progress < 1 && source.distanceToSquared(target) > epsilon * epsilon) {
        requestAnimationFrame(animate)
      } else {
        source.copy(target) // ensure exact target match at end
        resolve()
      }
    }

    requestAnimationFrame(animate)
  })
}
